import type { IconProps } from '../types/IconProps.ts';
export const Users: IconProps = {
    name: 'Users',
    children: [
        `<circle cx="10" cy="8" r="5" />`,
        `<path d="M18 21a8 8 0 1 0-16 0M18 4c.83 1.33 2 4.9 0 8.5M18 12.5c1.5 1.33 4.4 4.9 4 8.5" />`,
    ]
};